import script from "./VoiceRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&setup=true&lang=js"

import "./VoiceRecorder.vue?vue&type=style&index=0&id=32aa2cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32aa2cf2"]])

export default __exports__